export class DriveRepresentation {
  id: number;
  name: string;
}
